// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"documents_wrapper__2C1JC","documents":"documents_documents__3le1r","document":"documents_document__2xEUI"};